module.exports = __webpack_public_path__ + "img/Logo_iNoe_152px.e2e33589.png";